module.exports = "<div *ngIf=\"general.showLogin\">\r\n  <table >\r\n    <tr>\r\n      <td>\r\n        <img src=\"/assets/img/logo.png\" />\r\n        <br>\r\n        <br>\r\n        <table style=\"width:250px; height:100px; display:inline;\" >\r\n          <tr><td>\r\n            <div  id=\"signinDiv\">Conducting Google Sign-In...</div>\r\n          </td></tr>\r\n        </table>\r\n        \r\n      </td>\r\n    </tr>\r\n  </table>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/_Components/login/login.component.html
// module id = 410
// module chunks = 1